<template>
<div class="chapter">
<div class="inner_page">
<h2 class="CN" id="pt1"><a href="#/text/9780062365606_Contents#rpt1">part one</a></h2>
<p class="Part-headings_PTO1_Part_title_2"><span class="small"><a href="#/text/9780062365606_Contents#rpt1">ENGLAND</a></span></p>
<p class="FME1_Frontmatter_epigraph_other_1">The sweet habit of each other had begun to put lines around her mouth, lines that looked like quotation marks – as if everything she said had been said before.</p>
<p class="FME2_Frontmatter_epigraph_other_2">Lorrie Moore, <i>Agnes of Iowa</i>           </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062365606_Part_1.vue?78c4d418